import React from 'react';
import './blog-post.css';
import slumber1 from './pictures/slumber1.jpg';
import slumber2 from './pictures/slumber2.jpg';
import slumber3 from './pictures/slumber3.jpg';
import slumber4 from './pictures/slumber4.jpg';
import slumber5 from './pictures/slumber5.jpg';
import slumber6 from './pictures/slumber6.jpg';

//import reportWebVitals from './reportWebVitals';

const Slumber = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Slumber Party with SWE Recap</h2>
                    <p class="site-post-meta">January 19th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    On January 19th, WiC hosted a Slumber Party in collaboration with UW SWE! 
                    We did a Kahoot to test on rom-com movies and had a great time watching To All the Boys I’ve Loved Before. 
                    It was wonderful to see everyone’s creativity in making friendship bracelets!
                    <br></br>
                     
                    </p>
                    <img src={slumber1} alt="Group picture"/>
                    <img src={slumber2} alt="Group picture"/>
                    <img src={slumber3} alt="Group picture"/>
                    <img src={slumber4} alt="Group picture"/>
                    <img src={slumber5} alt="Group picture"/>
                    <img src={slumber6} alt="Friendship bracelet"/>
 
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Slumber;

